// extracted by mini-css-extract-plugin
module.exports = {"BlueLink":"BlueLink_BlueLink__3pSXi","BlueLink__text":"BlueLink_BlueLink__text__2FsLC"};